import React from "react"

const registradorContext = React.createContext(null)

export default registradorContext
